<template>
  <PModal
    title="Supprimer ce parapheur"
    @close="emit('cancel')"
    :model-value="open"
    :dialog-attrs="{ class: 'max-w-[600px]' }"
  >
    <template #default>
      <p>
        Toutes les données et tous les documents de ce parapheur seront définitivement supprimés. Souhaitez-vous
        continuer ?
      </p>
    </template>

    <template #actions>
      <div class="flex justify-end gap-2">
        <PButton type="button" mode="tertiary" @click="emit('cancel')" data-sentry-id="DeleteLetterFileModalCancelBtn">
          Annuler
        </PButton>
        <PButton
          type="button"
          mode="primary"
          @click="confirmer"
          :loading="loading"
          data-sentry-id="DeleteLetterFileModalConfirmBtn"
        >
          Confirmer
        </PButton>
      </div>
    </template>
  </PModal>
</template>

<script setup lang="ts">
import { PButton, PModal } from "@pasta/box-v2";
import { onMounted, ref } from "vue";

type Props = {
  open: boolean;
};
defineProps<Props>();

const emit = defineEmits<{
  (e: "confirm"): void;
  (e: "cancel"): void;
}>();

const loading = ref(false);

function confirmer() {
  loading.value = true;
  emit("confirm");
}

onMounted(() => {
  loading.value = false;
});
</script>
